import CardOrganisationProfile from "./component";

export default CardOrganisationProfile;